import { Component, OnInit, Inject, ViewEncapsulation } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material";
import { ServerService } from 'src/app/services/server.service';
import { ClipBoardService } from 'src/app/services/clipboard.service';

@Component({
  selector: 'app-assign-user-to-jobs',
  templateUrl: './assign-user-to-jobs.component.html',
  styleUrls: ['./assign-user-to-jobs.component.scss']
})
export class AssignUserToJobsComponent implements OnInit {

  authToken = localStorage.getItem('token')
  adminUser: any;
  selectedUser: any
  allDetail:any;
  heading:any;
  btnStatus = false;
  constructor(
    private dialogRef: MatDialogRef<AssignUserToJobsComponent>,
    private _serverService: ServerService,
    private clipBoardService: ClipBoardService,
    @Inject(MAT_DIALOG_DATA) public data
  ) {
   
    this.allDetail = this.data;

    const jobTypes = {
      escalation: 'Escalation',
      presales: 'Presales Job',
      creative: 'Creative Job',
      default: 'Marketing Job',
    }; 
    this.heading = jobTypes[this.allDetail.job_table_type] || jobTypes.default;
    
  }

  ngOnInit() {
    this.getAllVendorAdmin()
  }
  close() {
    this.dialogRef.close();
  }
  getAllVendorAdmin() {
    this._serverService.getallVendorAdminForCampaign(this.authToken).subscribe((data) => {
      this.adminUser = data.data;

    })
  }
  apply() {
    this.btnStatus = true
    let body = {
      // 'marketing_manager':this.selectedUser,
      // 'marketing_manager_id':this.selectedUser.id,
      "campaign_id": this.data.campaign_id,
      // 'assigned_user':this.selectedUser,
      'assigned_to_id': this.selectedUser
    }
    let url;
    if (this.data.job_table_type == 'presales') {
      url = 'campaign_module/pre_sales_jobs/' + this.data.id
    }
    else if (this.data.job_table_type == 'escalation') {
      url = 'campaign_module/escalation/' + this.data.id
    }
    else if (this.data.job_table_type == 'marketing') {
      url = 'campaign_module/marketing_jobs/' + this.data.id
    }
    else {
      url = 'campaign_module/creative_jobs/' + this.data.id
    }

    // let url = this.data.id;
    this._serverService.updateEscalationJobDetails(url, body, this.authToken).subscribe((data) => {
      this.dialogRef.close(data);
      this.clipBoardService.showMessgeInText("User Assigned Successfully", "success-snackbar")

    },
    error => {
     console.error('User Assigned failed', error);
     this.btnStatus = false;
     // this.showComponentLoader = false;
   })

  }
  userType(item) {
    return item.org_admin && !item.role
      ? 'Vendor Admin'
      : !item.org_admin && !item.role
      ? 'Vendor Standard User'
      : item.role;
  }
}